import { useMemo } from 'react'
import { CircularProgress, Stack, Typography } from '@mui/material'
import { useSearchParams } from 'react-router-dom'
import { useLazyGetParticipatingTeamsPageQuery } from '../../../../api/teams'
import type { TGetTeamsQueryParams } from '../../../../api/types/teams'
import { TeamsList } from '../../../../components/Teams/TeamsList'
import { useTeamsWindowedPage } from '../../../../hooks/useTeamsWindowedPage'

export const TeamsParticipating = () => {
  const [searchParams] = useSearchParams()

  const teamsQueryArgs = useMemo<TGetTeamsQueryParams>(() => {
    const query = searchParams.get('query')?.trim() ?? ''
    return query ? { query } : {}
  }, [searchParams])

  const resetKey = useMemo(() => JSON.stringify(teamsQueryArgs), [teamsQueryArgs])
  const [loadTeamsPage] = useLazyGetParticipatingTeamsPageQuery()
  const { items, hasMore, isInitialLoading, isFetchingMore, isError, loadMore } = useTeamsWindowedPage(
    resetKey,
    loadTeamsPage,
    teamsQueryArgs,
  )

  if (isInitialLoading && items.length === 0) {
    return (
      <Stack alignItems="center" justifyContent="center" minHeight="100%">
        <CircularProgress />
      </Stack>
    )
  }

  if (isError) {
    return (
      <Typography color="error" textAlign="center" px={2}>
        Не удалось загрузить команды
      </Typography>
    )
  }

  return (
    <TeamsList
      teams={items}
      hasMore={hasMore}
      isLoadingMore={isFetchingMore}
      onLoadMore={loadMore}
      emptyMessage="Вы пока не участвуете в командах"
    />
  )
}
